import React, { Component } from "react"

class MyMazdaUnauthRedirectBlock extends Component {
  constructor(props) {
    super(props)

    window.location = props.redirectUrl
  }

  render() {
    return null
  }
}

export default MyMazdaUnauthRedirectBlock



// WEBPACK FOOTER //
// ./src/blocks/mymazda/redirect/index.jsx